const general = {
  en: {
    safelabs: "SafeLabs",
    rightsReserved: "All rights reserved",
    name_bas: "RaidStorm",
    select_language: "Select language",
    support: "Support",
    product_safelabs: "A SafeLabs product",
    access: "Access",
    forgot_my_password: "Forgot my password",
    search_app: "Search",
    return: "Return",
    cancel: "Cancel",
    close: "Close",
    send: "Send",
    save: "Save",
    actions: "Actions",
    view: "View",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    remove: "Remove",
    ok: "Ok",
    back: "Back",
    next: "Next",
    forfeit: "Forfeit",
    stop: "Stop",
    required: "Obligatory",
    requiredFields: "*Required fields",
    sortLabel: "Order",
    sortAZ: "Order A-Z",
    sortZA: "Order Z-A",
    sortNew: "Latest",
    sortOld: "Older",
    yes: "Yes",
    no: "No",
    done: "Done",
    emptyListTitle: "This list is empty",
    emptyListDescription:
      "Try add new items to this section and see it growing!",
    searchNotFoundTitle: "Sorry, we could not find anything",
    searchNotFoundDescription:
      "Make sure your search is correct so we can help with results of it!",
    export: "Export",
    selectAnOption: "Select an Option",
    obsfucation: "Obsfucation",
    all: "All",
    total: "Total",
    allFields: "All Fields",
    searchResults:
      "<span class='font-medium'>Your search resulted in <strong>{in}</strong> out of <strong>{outOf}</strong> {module}</span>",
    totalResult:
      "<span class='font-medium'>Your search resulted in <strong>{outOf}</strong> {module}</span>",
    download: "Download"
  },
  pt: {
    safelabs: "SafeLabs",
    rightsReserved: "Todos os direitos reservados",
    name_bas: "RaidStorm",
    select_language: "Selecione o idioma",
    support: "Suporte",
    product_safelabs: "Um produto SafeLabs",
    access: "Acessar",
    forgot_my_password: "Esqueci minha senha",
    search_app: "Pesquisar",
    return: "Voltar",
    cancel: "Cancelar",
    close: "Fechar",
    send: "Enviar",
    save: "Salvar",
    actions: "Ações",
    view: "Visualizar",
    create: "Criar",
    edit: "Editar",
    delete: "Excluir",
    remove: "Remover",
    ok: "Ok",
    back: "Voltar",
    next: "Próximo",
    forfeit: "Desistir",
    stop: "Parar",
    required: "Obrigatório",
    requiredFields: "*Campos obrigatórios",
    sortLabel: "Ordernar",
    sortAZ: "Ordem A-Z",
    sortZA: "Ordem Z-A",
    sortNew: "Mais recentes",
    sortOld: "Mais antigos",
    yes: "Sim",
    no: "Não",
    done: "Done",
    emptyListTitle: "Esta lista está vazia",
    emptyListDescription:
      "Tente adicionar novos itens a esta seção e veja-a crescer!",
    searchNotFoundTitle: "Desculpe, não conseguimos encontrar nada",
    searchNotFoundDescription:
      "Certifique-se de que sua busca está correta para que possamos ajudar com os resultados dela!",
    export: "Exportar",
    selectAnOption: "Selecione uma opção",
    obsfucation: "Obsfucação",
    all: "Todos",
    total: "Total",
    allFields: "Todos os Campos",
    searchResults:
      "<span class='font-medium'>Sua busca resultou em <strong>{in}</strong> de <strong>{outOf}</strong> {module}</span>",
    totalResult:
      "<span class='font-medium'>Sua busca resultou em <strong>{outOf}</strong> {module}</span>",
    download: "Baixar"
  },
  es: {
    safelabs: "SafeLabs",
    rightsReserved: "Todos los derechos reservados",
    name_bas: "RaidStorm",
    select_language: "Seleccione el idioma",
    support: "Soporte",
    product_safelabs: "Un producto SafeLabs",
    access: "Acceda a",
    forgot_my_password: "Olvidé mi contraseña",
    search_app: "Busque en",
    return: "Volver",
    cancel: "Cancelar",
    close: "Cerrar",
    send: "Enviar",
    save: "Guardar",
    actions: "Acciones",
    view: "Ver",
    create: "Crear",
    edit: "Editar",
    delete: "Eliminar",
    remove: "Eliminar",
    ok: "Ok",
    back: "Volver",
    next: "Siguiente",
    forfeit: "Desistir",
    stop: "Stop",
    required: "Obligatorio",
    requiredFields: "*Campos obligatorios",
    sortLabel: "Ordernar",
    sortAZ: "Ordem A-Z",
    sortZA: "Ordem Z-A",
    sortNew: "Más reciente",
    sortOld: "Más antiguos",
    yes: "Si",
    no: "No",
    done: "Done",
    emptyListTitle: "Esta lista está vacía",
    emptyListDescription:
      "Pruebe a añadir nuevos artículos a esta sección y vea cómo crece.",
    searchNotFoundTitle: "Lo sentimos, no hemos podido encontrar nada",
    searchNotFoundDescription:
      "Asegúrate de que tu búsqueda es correcta para que podamos ayudarte con los resultados de la misma.",
    export: "Exportar",
    selectAnOption: "Seleccione una Opción",
    obsfucation: "Obsfucación",
    all: "Todos",
    total: "Total",
    allFields: "Todos os campos",
    searchResults:
      "<span class='font-medium'>Su búsqueda ha resultado en <strong>{in}</strong> de <strong>{outOf}</strong> {module}</span>",
    totalResult:
      "<span class='font-medium'>Su búsqueda ha resultado en <strong>{outOf}</strong> {module}</span>",
    download: "Descargar"
  }
}

export default general
